export default "__VITE_ASSET__38e70e36__"